import React from "react";
import Select from "react-select";

import _ from "lodash";

import { beautifyBuiltinPropName } from "@/util";
import { builtinPropNames } from "../sendBuiltinExamples";
import { themedSelectStyles } from "@/components/Dropdown/themedSelectStyles";
import { usePortalContainer } from "@/design-system/portalContainer";

const sendBuiltinPropNameOptions = builtinPropNames.map((name: string) => ({
  value: name,
  label: beautifyBuiltinPropName(name),
}));

type BuiltinPropNameOption = (typeof sendBuiltinPropNameOptions)[number];

const sendBuiltinPropNameOptionsMap = _(sendBuiltinPropNameOptions)
  .keyBy("value")
  .value() as Record<string, BuiltinPropNameOption>;

interface Props {
  originalBuiltinPropName: string;
  setOriginalBuiltinPropName: (value: string) => void;
  newPropName: string;
  setNewPropName: (value: string) => void;
}

function SendBuiltinPropertyInputs({
  originalBuiltinPropName,
  setOriginalBuiltinPropName,
  newPropName,
  setNewPropName,
}: Props) {
  const portalContainer = usePortalContainer();
  return (
    <>
      <Select
        styles={themedSelectStyles<BuiltinPropNameOption>({
          menuPortal: (base) => ({ ...base, zIndex: "var(--z-popover)" }),
        })}
        className="mt-2"
        placeholder="Builtin Property Name..."
        options={sendBuiltinPropNameOptions}
        value={sendBuiltinPropNameOptionsMap[originalBuiltinPropName]}
        onChange={(e) => e && setOriginalBuiltinPropName(e.value)}
        menuPortalTarget={portalContainer}
        menuPosition="fixed"
      />
      <input
        className="mt-2 w-full rounded border px-2 py-2 font-mono tracking-tight"
        placeholder="Send As..."
        value={newPropName}
        onChange={(e) => setNewPropName(e.target.value)}
      />
    </>
  );
}

export { SendBuiltinPropertyInputs };
